import React from 'react';
import PropTypes from 'prop-types';
import { CircleAlert } from 'lucide-react';
import { Tabs, Tab } from '@otcmarketsgroup/otcm-ui-lib';

const TabMenu = ({ items, activeTab, handleTabClick }) => {
  const handleOnClick = (e, item) => {
    handleTabClick(item);
  };

  return (
    <Tabs onChange={handleOnClick} value={activeTab}>
      {items.map(item => <Tab
          key={item.title}
          label={item.title}
          icon={!item.completed ? <CircleAlert size={16} color="var(--otc-warning)" /> : undefined}
          iconPosition='end'
          value={item.path} />)}
    </Tabs>
  );
};

TabMenu.propTypes = {
  activeTab: PropTypes.string,
  items: PropTypes.array,
  handleTabClick: PropTypes.func
};

export default TabMenu;
